// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"b955246cae42589035dc","655":"2957f02e6be690997746"}[chunkId] + ".js";
};